<template>
  <div>
    <search-loader v-if="loadingPage"></search-loader>
    <v-row justify="center" class="" no-gutters v-else-if="showResults">
      <v-col xl="9" lg="11" md="11" sm="12" cols="12">
        <v-row justify="center" class="xl-4 lg-4 pt-xl-4 pt-lg-4 pt-md-4 pb-xl-12 pb-lg-12 pb-md-8 pb-sm-4 pb-4" no-gutters>
          <v-col class="pr-3" cols="3" v-if="$vuetify.breakpoint.mdAndUp">
            <div class="mb-4 pr-1 text-left grey--text text--darken-2">
              <span>Resultados de busquedad para: <span class="font-weight-medium">'{{ searchValue }}'</span></span>
            </div>
          </v-col>
          <v-col class="pl-5" cols="9" v-if="$vuetify.breakpoint.mdAndUp">
            <div class="mb-4 pr-1 text-right grey--text text--darken-2">
              {{ products.count }}
              <span v-if="products.count == 1">Producto encontrado</span>
              <span v-else>Productos encontrados</span>
            </div>
          </v-col>
          <v-col class="pr-3" cols="3" v-if="$vuetify.breakpoint.mdAndUp">
            <filter-products :brands="products.brands" :conditions="products.conditions" :price="products.price" @filterProducts="applyFilter"></filter-products>
          </v-col>
          <v-col class="toolbar-quantity" v-if="$vuetify.breakpoint.smAndDown">
            <v-toolbar dense>
              <v-toolbar-title class="subtitle-2 grey--text">{{ products.count }}
                <span v-if="products.count == 1">Producto encontrado</span>
                <span v-else>Productos encontrados</span>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click="openFilterModal">
                <v-icon>mdi-filter-variant</v-icon>
              </v-btn>
            </v-toolbar>
          </v-col>
          <v-col class="pl-xl-5 pl-lg-5 pl-md-5" xl="9" lg="9" md="9" sm="12" cols="12">
            <div :class="$vuetify.breakpoint.mdAndUp ? 'card-border-bottom':  ''">
              <list-image-item-container class="card-border-top card-border-left card-border-right" v-for="(product, index) in products.products" :key="'search_product_'+product.product_id">
                <template v-slot:image>
                  <div class="product-image-container mx-xl-2 mx-lg-2 mx-md-2 mx-sm-2 mx-1" @click="goToProductDetail(product.slug)">
                    <v-img :class="['product-image', { 'product-image-not-available': getProductsTotalQuantities(index) === 0 }]" :src="getCoverImage(index)" aspect-ratio="1"></v-img>
                  </div>
                </template>
                <template v-slot:content>
                  <div class="pt-xl-4 pt-lg-4 pt-md-4 pt-sm-1 pt-2">
                    <div class="text--primary text-left font-weight-light text-lowercase product-title first-capital-letter mt-1">
                      {{product.name}}
                    </div>
                    <div class="headline label-price text-left font-weight-medium mt-1">{{ getHumanizedPrice(index) }}</div>
                    <div class="text-left product-subtitle body-2 grey--text text--darken-1 mt-xl-1 mt-lg-1 mt-md-1 mt-sm-1">{{ product.brand }}</div>
                    <div class="text-left product-subtitle body-2 mt-xl-1 mt-lg-1 mt-md-1 mt-sm-1 mt-1 product-not-available" v-if="getProductsTotalQuantities(index) === 0">Producto no disponible</div>
                    <div class="text-left product-subtitle body-2 mt-xl-1 mt-lg-1 mt-md-1 mt-sm-1 mt-1 free-shipping" v-else-if="isFreeShipping(index)">Envío gratis</div>
                    <div class="text-left body-2 mt-xl-1 mt-lg-2 mt-md-2 mt-sm-1 mt-1" v-else>Con envíos a nivel nacional</div>
                  </div>
                </template>
              </list-image-item-container>
              <v-card class="progress-container card-border-left card-border-right card-border-top" tile flat v-if="products.next">
                <v-progress-circular class="progress" indeterminate size="24" width="3" v-if="loading"></v-progress-circular>
                <v-btn text class="text-none load-more" small @click="getMoreProducts(products.next)" v-else>Cargar Mas</v-btn>
              </v-card>
            </div>
          </v-col>
        </v-row>
        <filter-products-modal :products="products" ref="filterproductsmodal" @filterProducts="applyFilter" />
      </v-col>
    </v-row>
    <v-row class="py-8" justify="center" align="center" no-gutters v-else-if="showNofFound">
      <v-col cols="10">
        <v-icon size="150" color="grey" v-if="$vuetify.breakpoint.mdAndUp">mdi-shield-search</v-icon>
        <v-icon class="mb-2" size="100" color="grey" v-else>mdi-shield-search</v-icon>
        <div class="headline font-weight-regular mb-xl-5 mb-lg-5 mb-md-5 mb-sm-4 mb-3 not-found-title">No hay productos que coincidan con tu búsqueda.</div>
        <div class="subtitle-1 font-weight-light mb-xl-1 mb-lg-1 mb-md-1 help-message">Revisa la ortografía de la palabra.</div>
        <div class="subtitle-1 font-weight-light mb-xl-1 mb-lg-1 mb-md-1 help-message">Consulta el nombre exacto del producto en internet.</div>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import navigationMixin from '@/mixins/navigation'
import SearchLoader from '@/loaders/SearchLoader'
import FilterProducts from '@/components/Product/FilterProducts'
import FilterProductsModal from '@/components/Product/FilterProductsModal'
import ListImageItemContainer from '@/components/List/ListImageItemContainer'

export default {
  name: 'Search',
  mixins: [navigationMixin],
  components: {
    SearchLoader,
    FilterProducts,
    FilterProductsModal,
    ListImageItemContainer
  },
  data () {
    return {
      loadingPage: false
    }
  },
  computed: {
    ...mapState('shared', ['loading']),
    ...mapState('product', ['products', 'searchConfig']),
    ...mapGetters('product', ['getCoverImage', 'getHumanizedPrice', 'isFreeShipping', 'getProductsTotalQuantities', 'getSearchValue', 'getCategorySearchValue']),
    showResults () {
      return !!this.products
    },
    showNofFound () {
      return !this.products || !this.products.products
    },
    searchValue () {
      return this.getSearchValue ? this.getSearchValue : this.getCategorySearchValue
    }
  },
  methods: {
    ...mapActions('product', ['searchProducts', 'getMoreProducts']),
    applyFilter (searchConfig) {
      this.goToRouteByName('Search', {}, searchConfig)
    },
    goToProductDetail (slug) {
      this.goToRouteByName('Product-detail', { slug })
    },
    openFilterModal () {
      this.$refs.filterproductsmodal.openModal()
    }
  },
  watch: {
    '$route.query': {
      async handler (query) {
        const search = (query.q ?? '').trim()
        if (!search && !query.category_id) {
          this.goToRouteByName('Home')
          return
        }

        this.loadingPage = true
        await this.searchProducts({ searchConfig: query })
        this.loadingPage = false
      },
      immediate: true
    }
  }
}
</script>
<style lang="scss" scoped>
  @import '~vuetify/src/styles/settings/_variables';
  .product-image {
    width: 10rem;
    height: 10rem;
    border-radius: 0.25rem;
  }
  .product-image-container {
    cursor: pointer;
    position: relative;
    width: 10rem;
    height: 10rem;
    border-radius: 0.25rem;
  }
  .toolbar-quantity{
    margin-bottom: 0.5px;
  }
  .product-title{
    font-size: 1.25em;
  }
  .product-not-available {
    color: #FF5252;
  }
  .product-image-not-available {
    opacity: 0.4;
  }
  .free-shipping{
    color: #00a650;
  }
  .progress-container {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .progress {
    color: #1E88E5;
  }

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    .product-image {
      width: 6.875rem;
      height: 6.875rem;
    }
    .product-image-container {
      position: relative;
      width: 6.875rem;
      height: 6.875rem;
    }
    .product-title{
      font-size: 1.063rem;
      line-height: 1.125rem;
    }
    .label-price{
      font-size: 1.375rem !important;
    }
    .product-subtitle{
      font-size: 0.813rem !important;
      line-height: 1rem;
    }
    .not-found-title{
      font-size: 1rem !important;
      line-height: 1.5rem;
    }
    .help-message{
      font-size: 0.875rem !important;
      line-height: 1.5rem;
    }
  }

  @media #{map-get($display-breakpoints, 'xs-only')} {
    .product-title{
      font-size: 0.938rem;
    }
  }
</style>
